import { useMemo } from "react";
export const useShouldValidate = (control, isDirty) => {
    return useMemo(() => {
        const formValues = control._formValues;
        const hasValueDeep = (obj) => {
            if (obj === null || obj === undefined) {
                return false;
            }
            if (typeof obj !== "object") {
                return obj !== "" && obj !== "[]";
            }
            if (Array.isArray(obj)) {
                return obj.some((item) => hasValueDeep(item));
            }
            return Object.values(obj).some((value) => hasValueDeep(value));
        };
        const hasValues = Object.values(formValues).some((value) => hasValueDeep(value));
        return isDirty || !hasValues;
    }, [control._formValues, isDirty]);
};
//# sourceMappingURL=useShouldValidate.js.map